

document.addEventListener("tbyb_cart_update", function () {
    var productId = tbyb.getSelectedVariants()?.productId;

    // Check if productId exists and is eligible
    if (productId && tbyb.viewManager.eligibilityService.getEligibilityStatus(productId).state) {
        // If the message is already displayed, return early
        if (document.querySelector("#toggle_deposit_text")) {
            return;
        }

        // Remove all instances of the element with the class 'tbyb-3umn2w'
        var toRemoveElements = document.querySelectorAll('.tbyb-3umn2w');
        toRemoveElements.forEach(function(element) {
            element.remove();
        });

        // If #blackcart_info element exists, show the message
        var elem = document.querySelector("#blackcart_info");
        if (elem) {
            var p = document.createElement("p");
            p.setAttribute("id", "toggle_deposit_text");

            // Concatenate the additional HTML code
            p.innerHTML = 'Test CoreWear, Without Paying.&nbsp;' +
                          '<span class="tbyb-19e93te"></span>' +
                          '<a data-testid=blackcart-learn-more href="#" role="button" class="tbyb-i3tm1q bc-info_link" id="blackcart_learn-more" data-testid="blackcart-learn-more" data-tbyb-tracking="learn_more" type="button">' +
                          'Learn More' +
                          '</a>';

            elem.prepend(p);
        }
    }

    // Code to change text content of bc-radio_label--text elements
    var labels = document.querySelectorAll('.bc-radio_label--text');

    // If there are at least two elements with the specified class
    if (labels.length >= 2) {
        labels[0].textContent = 'TRY IT WITHOUT PAYING';
        labels[1].textContent = 'PAY FOR IT TODAY';
    }
});

addEventListener('load', function () {
    if(tbyb){
        let interval = setInterval(function(){
            let learnMore = document.querySelector('[data-testid=blackcart-learn-more]');
            if(learnMore){
                learnMore.addEventListener("click", function(){tbyb.viewManager.showLearnMoreModal()});
                clearInterval(interval);
            }
        }, 1000);
    }
});